<template>
  <div id="home">
    <div class="content">
      <header>
        <div class="row-inner">
          <img class="logo logo-desktop" src="./../assets/img/logos/logo-driessen-desktop.svg" alt="Driessen Logo">
          <img class="logo logo-mobile" src="./../assets/img/logos/logo-driessen-mobile.svg" alt="Driessen Logo">
        </div>
        <div class="row-inner row-svg">
          <div class="title">
            <div class="pre-title">
              Test je
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="2153" height="609" viewBox="0 0 2153 609" class="main-title">
              <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="10"
                 transform="translate(5 5)">
                <path class="path-1" stroke="#B71234"
                      d="M45.5510805,302.556445 C-86.4489195,529.112891 81.5510805,758 380.55108,447 C468.287251,355.742645 529.55108,336.939549 591.773796,336.939549 C582.148772,368.490209 568.317077,414.345577 583.192114,412.597483 C598.067151,410.849388 617.317199,378.852496 625.192219,355.130724 C620.812935,386.211554 620.812935,401.894883 627.817225,401.26755 C652.441041,399.062139 666.688516,353.271264 674.192341,325.80758 C686.831126,337.452981 704.096221,341.474422 725.354233,334.294428 C728.854241,319.59567 743.612213,286.626263 756.854311,285.440246 C777.330558,283.606308 758.604316,321.726224 725.354233,334.294428 C720.10422,355.863055 730.073798,372.005535 748.218131,370.380453 C766.362463,368.755371 802.354424,334.111103 825.104481,285.08159 C835.604507,300.444484 843.479527,301.657203 854.854555,302.556445 C825.104481,343.603294 840.298637,354.746074 856.60456,349.391631 C874.787376,343.420863 924.190454,287.941259 927.583283,272.959757 C932.628423,250.682245 938.134174,224.76128 944.937997,194.849823 L912.562917,339.684258 C916.062926,323.387135 918.979599,310.019315 921.312939,299.580797 C927.312418,272.741288 959.813034,231.878307 973.813069,244.050669 C978.297849,247.949971 966.813052,278.243279 948.438006,281.807062 C948.438006,298.110382 951.938015,324.649434 968.563056,323.160426 C985.188098,321.671419 1022.39234,274.009752 1036.39238,255.493512 C1050.39241,236.977271 1070.51746,215.035393 1090.64251,224.741136 C1078.39248,256.526902 1059.14243,304.28392 1038.14238,306.164772 C1024.14235,307.418674 1017.74545,284.263868 1036.39238,255.493512 C1017.74545,284.263868 1024.14235,307.418674 1038.14238,306.164772 C1067.01745,303.578601 1094.93335,211.520742 1089.68334,227.335256 C1084.43333,243.149771 1075.29576,287.633679 1071.45907,304.671842 C1067.62239,321.710006 1061.34861,365.09235 1042.38054,366.791209 C1029.83058,367.915235 1031.88051,352.048305 1034.50552,345.100067 C1047.98103,309.431176 1114.62181,290.916205 1139.92845,244.001867 C1146.92847,217.097936 1160.9285,192.252035 1178.42854,194.520734 C1195.92859,196.789433 1165.30351,247.483284 1139.92845,244.001867 C1135.55344,262.68154 1148.74871,281.211032 1164.49875,279.800393 C1222.14892,274.637005 1279.13796,150.817672 1279.13796,120.330426 C1279.13796,96.7445565 1235.21952,128.014167 1235.21952,212.407824 C1235.21952,245.066911 1249.12509,252.386487 1261.37512,251.289323 C1291.94321,248.551518 1328.89772,197.046924 1338.58725,153.85348 C1332.5464,178.412921 1310.80638,235.539241 1337.05645,233.188176 C1363.30651,230.837111 1389.90416,143.10943 1389.90416,143.10943 C1389.90416,143.10943 1363.93385,224.885382 1390.34741,218.782101 C1416.76097,212.678819 1450.55422,160.55784 1455.80423,150.497438 C1458.72091,138.727983 1465.42926,109.676263 1475.92928,63.3422788 L1441.8042,210.251488 C1456.38757,146.92879 1475.34595,114.222523 1498.67934,112.132687 C1518.65742,110.343368 1489.05432,150.396479 1478.55429,151.336905 C1478.55429,164.763169 1483.14991,193.503627 1507.88231,192.395361 C1539.83472,190.963565 1575.40592,165.910051 1619.14625,122.09328 C1687.24746,53.8730544 1770.06287,5.40198123 1899.55108,13.984862 C2029.03929,22.5677428 2100.55108,68.6608519 2142.55108,120.330426"
                      opacity=".5"></path>
                <path class="path-2" stroke="#FFF"
                      d="M45.5510805,289.556445 C-86.4489195,516.112891 81.5510805,745 380.55108,434 C468.287251,342.742645 529.55108,323.939549 591.773796,323.939549 C582.148772,355.490209 568.317077,401.345577 583.192114,399.597483 C598.067151,397.849388 617.317199,365.852496 625.192219,342.130724 C620.812935,373.211554 620.812935,388.894883 627.817225,388.26755 C652.441041,386.062139 666.688516,340.271264 674.192341,312.80758 C686.831126,324.452981 704.096221,328.474422 725.354233,321.294428 C728.854241,306.59567 743.612213,273.626263 756.854311,272.440246 C777.330558,270.606308 758.604316,308.726224 725.354233,321.294428 C720.10422,342.863055 730.073798,359.005535 748.218131,357.380453 C766.362463,355.755371 802.354424,321.111103 825.104481,272.08159 C835.604507,287.444484 843.479527,288.657203 854.854555,289.556445 C825.104481,330.603294 840.298637,341.746074 856.60456,336.391631 C874.787376,330.420863 924.190454,274.941259 927.583283,259.959757 C932.628423,237.682245 938.134174,211.76128 944.937997,181.849823 L912.562917,326.684258 C916.062926,310.387135 918.979599,297.019315 921.312939,286.580797 C927.312418,259.741288 959.813034,218.878307 973.813069,231.050669 C978.297849,234.949971 966.813052,265.243279 948.438006,268.807062 C948.438006,285.110382 951.938015,311.649434 968.563056,310.160426 C985.188098,308.671419 1022.39234,261.009752 1036.39238,242.493512 C1050.39241,223.977271 1070.51746,202.035393 1090.64251,211.741136 C1078.39248,243.526902 1059.14243,291.28392 1038.14238,293.164772 C1024.14235,294.418674 1017.74545,271.263868 1036.39238,242.493512 C1017.74545,271.263868 1024.14235,294.418674 1038.14238,293.164772 C1067.01745,290.578601 1094.93335,198.520742 1089.68334,214.335256 C1084.43333,230.149771 1075.29576,274.633679 1071.45907,291.671842 C1067.62239,308.710006 1061.34861,352.09235 1042.38054,353.791209 C1029.83058,354.915235 1031.88051,339.048305 1034.50552,332.100067 C1047.98103,296.431176 1114.62181,277.916205 1139.92845,231.001867 C1146.92847,204.097936 1160.9285,179.252035 1178.42854,181.520734 C1195.92859,183.789433 1165.30351,234.483284 1139.92845,231.001867 C1135.55344,249.68154 1148.74871,268.211032 1164.49875,266.800393 C1222.14892,261.637005 1279.13796,137.817672 1279.13796,107.330426 C1279.13796,83.7445565 1235.21952,115.014167 1235.21952,199.407824 C1235.21952,232.066911 1249.12509,239.386487 1261.37512,238.289323 C1291.94321,235.551518 1328.89772,184.046924 1338.58725,140.85348 C1332.5464,165.412921 1310.80638,222.539241 1337.05645,220.188176 C1363.30651,217.837111 1389.90416,130.10943 1389.90416,130.10943 C1389.90416,130.10943 1363.93385,211.885382 1390.34741,205.782101 C1416.76097,199.678819 1450.55422,147.55784 1455.80423,137.497438 C1458.72091,125.727983 1465.42926,96.6762629 1475.92928,50.3422788 L1441.8042,197.251488 C1456.38757,133.92879 1475.34595,101.222523 1498.67934,99.1326874 C1518.65742,97.3433678 1489.05432,137.396479 1478.55429,138.336905 C1478.55429,151.763169 1483.14991,180.503627 1507.88231,179.395361 C1539.83472,177.963565 1575.40592,152.910051 1619.14625,109.09328 C1687.24746,40.8730544 1770.06287,-7.59801877 1899.55108,0.98486202 C2029.03929,9.56774281 2100.55108,55.6608519 2142.55108,107.330426"></path>
              </g>
            </svg>
          </div>
        </div>
      </header>
      <main>
        <h1>Test je werkgeluk</h1>
        <div class="row-inner">
          <div class="content-row content-row--intro">
            <div class="heading-mobile">
              <h2 class="white">Hoe werkgelukkig ben jij?</h2>
              <router-link :to="{ name: 'Quiz'}" class="button to-quiz">
                doe de test
              </router-link>
            </div>
            <div class="image row-item-left">
              <img src="./../assets/img/photos/girl-child.png"/>
            </div>
            <div class="text row-item-right">
              <div class="button-container">
                <router-link :to="{ name: 'Quiz'}" class="button to-quiz">
                  doe de test
                </router-link>
                <span>Ontdek in 2 minuten of je werkgelukkig bent</span>
              </div>
              <h2 class="white">Hoe werkgelukkig ben jij?</h2>
              <p class="white">
                Anderen gelukkig maken is de meest effectieve manier om zelf gelukkig te worden. Maar er zijn meerdere
                factoren die je geluk beïnvloeden. Een van de dingen die veel invloed heeft op je geluk is je
                werkgeluk.
              </p>
              <h3 class="white">De test geeft inzicht in je:</h3>
              <ul class="white checklist">
                <li>relatie met collega's</li>
                <li>competenties</li>
                <li>vrijheid in je werk</li>
                <li>manier van mensen gelukkig maken</li>
              </ul>
              <router-link :to="{ name: 'Quiz'}" class="button to-quiz">
                doe de test
              </router-link>
            </div>
          </div>
          <div class="content-row content-row--above-video">
            <h2 class="white">Geluk werkt door</h2>
            <p class="white">
              Mensen die werken in de sectoren overheid, onderwijs, zorg en cultuur maken anderen gelukkig. En daarvoor hebben wij het bewijs. Wij verrasten leerlingcoördinator Theo, uitvoerend gebiedstoezichthouder Annelies en medewerker Publiekszaken Jacqueline met hartverwarmende reacties van
              degenen die zij gelukkig maken.
            </p>
          </div>

          <div class="content-row content-row--videos">
            <silentbox-group>
              <silentbox-single src="https://www.youtube.com/watch?v=n7rw34b8YIQ">
                <div class="silentbox-single__image" style="background-image:url('https://img.youtube.com/vi/n7rw34b8YIQ/maxresdefault.jpg');"></div>
              </silentbox-single>
              <silentbox-single src="https://www.youtube.com/watch?v=MnFfMVr-t3k">
                <div class="silentbox-single__image" style="background-image:url('https://img.youtube.com/vi/MnFfMVr-t3k/maxresdefault.jpg');"></div>
              </silentbox-single>
              <silentbox-single src="https://www.youtube.com/watch?v=UssMYMl_NRI">
                <div class="silentbox-single__image" style="background-image:url('https://img.youtube.com/vi/UssMYMl_NRI/maxresdefault.jpg');"></div>
              </silentbox-single>
            </silentbox-group>
          </div>
          <div class="content-row content-row--bottom">
            <div class="text row-item-left">
              <h2 class="white">Vind je werkgeluk bij Driessen</h2>
              <p class="white">
                Wij maken werk van je baan in de overheid, het onderwijs, de zorg of de culturele sector. Maar
                belangrijker nog; wij maken werk van je werkgeluk. Goed om te weten is dat we dit doen bij 1.200
                organisaties, voor ruim 15.000 talenten. Talenten die zich elke dag inzetten om anderen te helpen,
                anderen iets te leren of voor anderen te zorgen. Talenten zoals jij. Want jij maakt met je werk de
                wereld elke dag weer een stukje mooier. Een stukje gelukkiger.
              </p>
              <div>

              </div>
              <div>
                <a class="button button--margin" href="https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">bekijk onze vacatures</a>
              </div>
              <div class="button-container">
                of &nbsp;&nbsp;<a class="button" href="https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">schrijf je gratis in</a>
              </div>
            </div>
            <div class="image row-item-right">
              <img src="./../assets/img/photos/boy-keyboard.png"/>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <div class="row-inner">
          <div class="footer-content">
            <div class="logo-footer">
              <img class="logo-drop" src="./../assets/img/logos/logo-driessen-drop.svg" alt="Driessen Logo">
            </div>
            <div class="social-links follow">
              <span class="label">Volg ons</span>
              <ul>
                <li class="facebook">
                  <a href="https://www.facebook.com/driessen.nl" target="_blank" rel="noopener noreferrer">Facebook</a>
                </li>
                <li class="linkedin">
                  <a href="https://www.linkedin.com/company/driessen-nl" target="_blank" rel="noopener noreferrer">LinkedIn</a>
                </li>
                <li class="twitter">
                  <a href="https://twitter.com/Driessen_nl"
                     target="_blank" rel="noopener noreferrer">Twitter</a>
                </li>
                <li class="youtube">
                  <a href="https://www.youtube.com/user/DriessenHRM"
                     target="_blank" rel="noopener noreferrer">Whatsapp</a>
                </li>
                <li class="instagram">
                  <a href="https://www.instagram.com/driessen.nl"
                     target="_blank" rel="noopener noreferrer">Instagram</a>
                </li>
              </ul>
            </div>
            <div class="footer-bottom">
              <a target="_blank" href="/cookies">Cookies</a>&nbsp; &nbsp;
              <a target="_blank" href="/general-conditions">Voorwaarden</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Home',
    data() {
      return {}
    },
    methods: {
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.toggleBodyClass('addClass', 'home');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'home');
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Home.vue